import { ref } from 'vue'

/**
 * Which request detail tab is currently in edit mode.
 *
 * The screen header sits above the tab strip, outside every tab's own component tree,
 * so it cannot be handed the tab's edit state through props: it is mirrored here from
 * each tab's `editUpdate` callback and read back by the header. Module level, because
 * the two live in separate trees and there is only ever one request details screen open.
 */
const editStates = ref({})

export function useRequestTabsEdit () {
  const setTabEdit = (tabKey, value) => {
    if (!tabKey) {
      return
    }

    // A fresh object rather than a mutation, so a key the header has not seen before
    // still reaches it.
    editStates.value = {
      ...editStates.value,
      [tabKey]: !!value
    }
  }

  const isTabEditing = (tabKey) => !!editStates.value[tabKey]

  return {
    editStates,
    setTabEdit,
    isTabEditing
  }
}
